import type { UseFormReturn } from "react-hook-form"
import type { FIELD } from "../types/form-types"
import { getCommonAttributes } from "../utils/attributes-extractor"
import { Acknowledgement } from "./fields/acknowledgement"
import { Address } from "./fields/address"
import { CheckboxField } from "./fields/checkbox"
import { CountryField } from "./fields/country"
import { DateField } from "./fields/date"
import { Email } from "./fields/email"
import { FileUploadField } from "./fields/file"
import { MultiSelectDropdown } from "./fields/multi-select"
import { Number } from "./fields/number"
import { PaymentOneField } from "./fields/registration-fee"
// import { PaymentTwoField } from "./fields/program-fee"
import Payment from "./fields/payment"
import { PhoneNumber } from "./fields/phone-number"
import { ProgramField } from "./fields/program"
import { RadioField } from "./fields/radio"
import { RichText } from "./fields/rich-text"
import { SelectField } from "./fields/select"
import { SpecializationField } from "./fields/specialization"
import { StateField } from "./fields/state"
import { Text } from "./fields/text"
import { TextAreaField } from "./fields/text-area"
import { ProgramTypeField } from "./fields/program-type"
import { DebId } from "./fields/deb-id"

interface FieldFactoryProps {
	field: FIELD
	form: UseFormReturn
}

export const FieldFactory = ({ field, form }: FieldFactoryProps) => {
	const commonAttributes = getCommonAttributes(field.attributes)
	const commonProps = {
		commonAttributes: commonAttributes,
		field: field,
		form: form,
	}

	switch (field.field_type) {
		case "ACKNOWLEDGEMENT":
			return <Acknowledgement {...commonProps} />
		case "ABC_ID":
		case "TEXT":
			return <Text {...commonProps} />
		case "POSTAL_CODE":
		case "NUMBER":
			return <Number {...commonProps} />
		case "EMAIL":
			return <Email {...commonProps} />
		case "DATE":
			return <DateField {...commonProps} />
		case "RADIO":
			return <RadioField {...commonProps} />
		case "CHECKBOX":
			return <CheckboxField {...commonProps} />
		case "FILE":
			return <FileUploadField {...commonProps} />
		case "AADHAR":
			return <Text {...commonProps} />
		case "TEL":
			return <PhoneNumber {...commonProps} />
		case "TEXT_AREA":
			return <TextAreaField {...commonProps} />
		case "SELECT":
			return <SelectField {...commonProps} />
		case "MULTI_SELECT":
			return <MultiSelectDropdown {...commonProps} />
		case "PROGRAM_TYPE":
			return <ProgramTypeField {...commonProps} />
		case "PROGRAM":
			return <ProgramField {...commonProps} />
		case "SPECIALIZATION":
			return <SpecializationField {...commonProps} />
		case "COUNTRY":
			return <CountryField {...commonProps} />
		case "STATE":
			return <StateField {...commonProps} />
		case "ADDRESS":
			return <Address {...commonProps} />
		case "DEB_ID":
			return <DebId {...commonProps} />
		case "PAYMENT_ONE":
			return (
				<PaymentOneField
					config={field}
					form={form}
				/>
			)
		case "PAYMENT_TWO":
			return (
				<Payment
					config={field}
					form={form}
				/>
			)
		// decorator fields
		case "RICH_TEXT":
			return <RichText field={field} />
		default:
			return <p>unsupported field type</p>
	}
}
